import axios from 'axios';
import { Dispatch } from 'redux';
import {
  ItemlookupAction,
  ItemlookupActionTypes
} from '../../types/itemlookup';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

const CancelToken = axios.CancelToken;
let cancelItemlookup: any = null;
let cancelItemlookupBins: any = null;

export const getItemlookup =
  (text: string) => async (dispatch: Dispatch<ItemlookupAction | any>) => {
    try {
      dispatch({
        type: ItemlookupActionTypes.SET_NS_ITEM_LOADING
      });

      if (cancelItemlookup) {
        cancelItemlookup();
        cancelItemlookup = null;
      }

      const config = {
        cancelToken: new CancelToken(function executor(c) {
          cancelItemlookup = c;
        })
      };

      const res = await axios.get(
        `/api/ns/item?sku=${encodeURIComponent(text ? text.trim() : '')}`,
        config
      );
      dispatch({
        type: ItemlookupActionTypes.GET_NS_ITEM,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: ItemlookupActionTypes.GET_NS_ITEM,
        payload: []
      });
    }
  };

export const getItemlookupBins =
  (text: string) => async (dispatch: Dispatch<ItemlookupAction | any>) => {
    try {
      dispatch({
        type: ItemlookupActionTypes.SET_NS_ITEM_BINS_LOADING
      });

      if (cancelItemlookupBins) {
        cancelItemlookupBins();
        cancelItemlookupBins = null;
      }

      const config = {
        cancelToken: new CancelToken(function executor(c) {
          cancelItemlookupBins = c;
        })
      };

      const res = await axios.get(
        `/api/ns/itemBins?sku=${encodeURIComponent(text ? text.trim() : '')}`,
        config
      );
      dispatch({
        type: ItemlookupActionTypes.GET_NS_ITEM_BINS,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: ItemlookupActionTypes.GET_NS_ITEM_BINS,
        payload: []
      });
    }
  };

export const clearItemlookup =
  () => async (dispatch: Dispatch<ItemlookupAction>) => {
    dispatch({
      type: ItemlookupActionTypes.CLEAR_ITEMLOOKUP
    });
  };
